export default {
  data: [],
  pagination: {
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
    filters: null
  },
  selectedTab: null,
  selectedType: null
};
